export const tabs = () => {
  const tabButtons = document.querySelectorAll('.js-tabs-body .js-tab');
  const tabContents = document.querySelectorAll('[data-content]');

  tabButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;

      tabButtons.forEach((b) => b.classList.remove('active'));
      tabContents.forEach((c) => c.classList.remove('active'));

      btn.classList.add('active');
      const currentContent = document.querySelector(`[data-content="${target}"]`);
      if (currentContent) {
        currentContent.classList.add('active');
      }
    });
  });

}

